<div class="adaptive-grow-1">
    <div class="fluent-container form-body">
        <div class="title-color">
            <h1>
                {{ data.secure ? 'DESENCRIPTAR DATOS' : 'ENCRIPTAR DATOS' }}
            </h1>
        </div>

        <p>
            {{
                otpRequested
                    ? 'Por favor ingrese el código OTP que ha sido enviado a su correo.'
                    : data.secure
                    ? 'Este registro está encriptado. Solicita un código OTP para desencriptado.'
                    : 'Este registro no está encriptado. Solicita un código OTP para encriptarlo.'
            }}
        </p>

        <div *ngIf="!otpRequested" class="button-row">
            <button class="primary-button" type="button" (click)="requestOtp()">
                <span class="button-content"
                    ><mat-icon>sms</mat-icon>Solicitar código</span
                >
            </button>
            <button
                class="secondary-button"
                type="button"
                (click)="closeDialog()"
            >
                <span class="button-content">
                    <mat-icon>close</mat-icon>
                    Cancelar
                </span>
            </button>
        </div>

        <div class="form-body" *ngIf="otpRequested">
            <form [formGroup]="otpForm" (ngSubmit)="encrypt()">
                <div class="line ">
                    <div class="column-md-12 column-lg-12 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>OTP</mat-label>
                            <input
                                matInput
                                placeholder="OTP"
                                formControlName="otp"
                                oninput="this.value = this.value.toUpperCase()"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="otpForm.get('otp')?.hasError('required')"
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"
                        ><mat-icon
                            [fontIcon]="data.secure ? 'lock_open' : 'lock'"
                        ></mat-icon>
                        {{ data.secure ? 'Desencriptar' : 'Encriptar' }}</span
                    >
                </button>
                <button
                    type="button"
                    (click)="closeDialog()"
                    class="secondary-button"
                    id="cancelar"
                >
                    <span class="button-content"
                        ><mat-icon>close</mat-icon>Cancelar</span
                    >
                </button>
            </form>
        </div>
    </div>
</div>
